import { h } from '@stencil/core/internal/client';
import { S as Skeleton } from './skeleton.js';
import './details.js';

const FormBlock = () => (h("div", { class: "row gap-3" },
    h("div", { class: "col-12" },
        h(Skeleton, { width: "25%" })),
    h("div", { class: "col-12" },
        h(Skeleton, { width: "100%" })),
    h("div", { class: "col-12 d-flex gap-3" },
        h(Skeleton, { width: "50%" }),
        h(Skeleton, { width: "50%" })),
    h("div", { class: "col-12 d-flex gap-3" },
        h(Skeleton, { width: "65%" }),
        h(Skeleton, { width: "35%" }))));
const PaymentProvisioningLoading = () => {
    return (h("div", { class: "row gap-5" },
        h("div", { class: "col-12" },
            h(Skeleton, { width: "40%", height: "40px" })),
        h(FormBlock, null),
        h(FormBlock, null),
        h(FormBlock, null)));
};

export { PaymentProvisioningLoading as P };
